module.exports = __webpack_public_path__ + "static/mapaPokryti-ff8ce97f04322611b308b8a3826d223d.svg";